<template>
  <Transition name="bottom-panel-transition">
    <div v-show="isVisible" class="bottom-panel fixed bottom-0 left-0 right-0 z-[1500]">
      <Card class="glass-card">
        <template #content>
          <div id="betDockTarget" ref="targetRef"></div>
        </template>
      </Card>
    </div>
  </Transition>
</template>

<script setup>
import Card from 'primevue/card'
import { computed, onMounted, onUnmounted, ref } from "vue"

const props = defineProps({
  visible: {
    type: Boolean,
    default: true
  }
})

const hasContent = ref(false)
const targetRef = ref(null)
let observer = null
const ro = new ResizeObserver(updateDockHeight)

function checkContent() {
  hasContent.value = !!targetRef.value && targetRef.value.childElementCount > 0
}

function updateDockHeight() {
  const panel = document.querySelector('.bottom-panel')
  const height = panel?.getBoundingClientRect().height ?? 0
  document.documentElement.style.setProperty('--dock-height', `${height + 16}px`) // 16px = 1rem margin above
}

onMounted(() => {
  checkContent()

  observer = new MutationObserver(() => {
    checkContent()
    updateDockHeight()
  })

  if (targetRef.value) {
    observer.observe(targetRef.value, { childList: true, subtree: true })
  }

  const panel = document.querySelector('.bottom-panel')
  if (panel) ro.observe(panel)

  updateDockHeight()
})

onUnmounted(() => {
  observer?.disconnect()
  ro.disconnect()
  document.documentElement.style.setProperty('--dock-height', '0px')
})

const isVisible = computed(() =>
    (props.visible === true || props.visible === 'true') && hasContent.value
)
</script>

<style scoped>
.bottom-panel {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);

  width: calc(100% - 2rem);
  max-width: 600px;
  z-index: 1500;
}

.glass-card {
  /* Default Desktop Look */
  background: hsl(var(--card) / 0.35);
  backdrop-filter: blur(5px) saturate(50%);
  -webkit-backdrop-filter: blur(5px) saturate(50%);
  
  border: 1px solid hsl(var(--border));
  border-radius: var(--radius);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

:deep(.p-card-body)
{
  padding: 12px 12px;
}

/* ---------- TRANSITION ---------- */
.bottom-panel-transition-enter-active,
.bottom-panel-transition-leave-active {
  transition: all 0.25s ease;
}

.bottom-panel-transition-enter-from,
.bottom-panel-transition-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.bottom-panel-transition-enter-to,
.bottom-panel-transition-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
/* -------------------------------- */

@media (max-width: 830px) {
  .bottom-panel {
    width: 95vw;
  }

  .glass-card {
    background: hsl(var(--card) / 0.35);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);

    border: 1px solid hsl(var(--border));
    border-radius: 2rem;

    box-shadow: 
      0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06),
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
}
</style>